var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.roles,"item-text":"display_name","item-value":"id","label":"Roller","multiple":"","dense":""},on:{"blur":() => _vm.$emit('update:selectedRoles', _vm.selectedRoles)},model:{value:(_vm.selectedRoles),callback:function ($$v) {_vm.selectedRoles=$$v},expression:"selectedRoles"}})
}
var staticRenderFns = []

export { render, staticRenderFns }